import { render } from "./ChooseGeoFenceColor.vue?vue&type=template&id=4f798a16&scoped=true"
import script from "./ChooseGeoFenceColor.vue?vue&type=script&lang=js"
export * from "./ChooseGeoFenceColor.vue?vue&type=script&lang=js"

import "./ChooseGeoFenceColor.vue?vue&type=style&index=0&id=4f798a16&scoped=true&lang=scss"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f798a16"]])

export default __exports__